import * as Namespaces from './namespaces'

const locales = {
	[Namespaces.PARENTS]: {
		el: {
			'Address': 'Διεύθυνση',
			'School': 'Σχολείο',
			'Sch.Year': 'Σχ.έτος',
			'Itineraries': 'Δρομολόγια',
			'Guardian Name': 'ΑΦΜ Κηδεμόνα',
			'Starting Point': 'Αφετηρία',
			'End Point': 'Τέρμα',
			'Itinerary to school': 'Δρομολόγιο προς το σχολείο',
			'Itinerary from school': 'Δρομολόγιο από το σχολείο',
			'Sponsor': 'Ανάδοχος',
			'Status': 'Κατάσταση',
			'Transfer Type': 'Μέσο Μεταφοράς',
			'Appear to map': 'Εμφάνιση στον χάρτη',
			'toSchool': 'Δρομολόγιο για το σχολείο',
			'fromSchool': 'Δρομολόγιο από το σχολείο',
			'Save Point': 'Αποθήκευση Σημείου',
			'Save Point For All Routes For Child': 'Αποθήκευση Σημείου Για Όλα Τα Δρομολόγια Του Παιδιού',
			'Save Point For All Routes For All Children': 'Αποθήκευση Σημείου Για Όλα Τα Δρομολόγια Όλων Των Παιδιών',
			'Bus stops & Finally': 'Στάσεις & Τέρμα',
			'Stated home address': 'Δηλωμένη διεύθυνση οικίας',
			'Selected home address': 'Επιλεγμένη διεύθυνση οικίας',
			'School Code' : 'Κωδικός Σχ.',
			'School Mail' : 'Email Σχ.',
			'Get instant access to information about your child`s transport, track routes and stops.' : 'Αποκτήστε άμεση πρόσβαση σε πληροφορίες για τη μεταφορά του παιδιού σας, παρακολουθήστε τις διαδρομές και τις στάσεις.',
			'Edit Address' : 'Επεξεργασία Διεύθυνσης',
		},
		en: {
			'toSchool': 'Route to school',
			'fromSchool': 'Route from school',
			'Guardian Name': 'TIN Guardian',
			'Sch.Year' : 'School Year',
			'Itinerary to school': 'Route to school',
			'Itineraries': 'Routes',
			'Appear to map': 'Show on map',
		}
	},
}

export default locales